import type { ListType } from '../models/app';
import type { GroceryNeedLoveFieldType } from '@/models/grocery';

export const needLoveTypeList: ListType[] = [
  { id: 1, key: 'otherCircumstances', label: 'Other Circumstances' },
  { id: 2, key: 'adjustmentRequestByOperator', label: 'Adjustment Request by Operator' },
  { id: 3, key: 'vaAdjustmentRequestUpdate', label: 'VA Adjustment Request Update' },
  { id: 4, key: 'chargeError', label: 'Charge Error' },
  { id: 5, key: 'damagedItemsDispute', label: 'Damaged Items Dispute' },
  { id: 6, key: 'missingWrongPoorReplacement', label: 'Missing, Wrong, or Poor Replacement' },
  { id: 7, key: 'poorServiceByIC', label: 'Poor Service by IC / Tip Removal' },
  { id: 8, key: 'operatorError', label: 'Operator Error' },
  { id: 9, key: 'supervisorInteraction', label: 'Supervisor Interaction' },
  { id: 10, key: 'escalatedBug', label: 'Escalated Bug/Tech Issue to IC' },
  { id: 11, key: 'missingOrder', label: 'Missing Order' },
];

const typeOfRefundField: GroceryNeedLoveFieldType = {
  label: 'Type of Refund',
  type: 'select',
  options: [
    { id: 1, key: 'Credit', label: 'Credit' },
    { id: 2, key: 'Card', label: 'Card' },
  ],
  required: true,
};

export const needLoveFields: Record<string, GroceryNeedLoveFieldType[]> = {
  otherCircumstances: [
    {
      label: 'Call Log Id',
      type: 'input',
      required: true,
    },
    {
      label: 'What is the customers issue about',
      type: 'select',
      options: [
        {
          id: 1,
          key: 'Did not not include APT, Unit, Condo, BLDG in address field',
          label: 'Did not not include APT, Unit, Condo, BLDG in address field',
        },
        { id: 2, key: 'Did not enter proper replacement Item', label: 'Did not enter proper replacement Item' },
        {
          id: 3,
          key: 'Did Not enter Instructions for specific Item in the list',
          label: 'Did Not enter Instructions for specific Item in the list',
        },
        { id: 4, key: 'Did Not Select NO Replacement', label: 'Did Not Select NO Replacement' },
        { id: 5, key: 'Did Not Submit NL', label: 'Did Not Submit NL' },
        { id: 6, key: 'Did not select right quantity of item', label: 'Did not select right quantity of item' },
        { id: 7, key: 'Sent Groceries to Wrong Address', label: 'Sent Groceries to Wrong Address' },
        { id: 8, key: 'No Shopper notes', label: 'No Shopper notes' },
        { id: 9, key: 'Wrong Dashboard Shopper Note ', label: 'Wrong Dashboard Shopper Note ' },
        { id: 10, key: 'Item Not Added to Cart', label: 'Item Not Added to Cart' },
        { id: 11, key: 'Added Incorrect Item', label: 'Added Incorrect Item' },
        { id: 12, key: 'Did Not Submit Grocery Order ID', label: 'Did Not Submit Grocery Order ID' },
        { id: 13, key: 'Created incorrect NL', label: 'Created incorrect NL' },
        { id: 14, key: 'Miss information to the cx', label: 'Miss information to the cx' },
        { id: 15, key: 'Failed to add call log note', label: 'Failed to add call log note' },
        { id: 16, key: 'Incorrect delivery time and date', label: 'Incorrect delivery time and date' },
        { id: 17, key: 'Incorrect order total given to the customer', label: 'Incorrect order total given to the customer' },
        { id: 18, key: 'Other', label: 'Other' },
      ],
      required: true,
    },
    {
      label: 'Details',
      type: 'text',
      required: true,
      full: true,
    },
    {
      label: 'Incorrect Item(s): description & Cost per Item',
      type: 'text',
      required: true,
    },
    {
      label: 'Correct Item(s): description & Cost per Item',
      type: 'text',
      required: true,
    },
    typeOfRefundField,
  ],
  adjustmentRequestByOperator: [
    {
      label: 'Adjustment Type',
      type: 'select',
      options: [
        { id: 1, key: 'Refund', label: 'Refund' },
        { id: 2, key: 'Charge', label: 'Charge' },
        { id: 3, key: 'to Add Credit', label: 'to Add Credit' },
        { id: 4, key: 'to Remove Credit', label: 'to Remove Credit' },
      ],
      required: true,
    },
    {
      label: 'Amount(s)',
      type: 'number',
      required: true,
    },
    {
      label: 'Details',
      type: 'text',
      required: true,
      full: true,
    },
  ],
  vaAdjustmentRequestUpdate: [
    {
      label: 'Adjustment Type',
      type: 'select',
      options: [
        { id: 1, key: 'Refund Processed', label: 'Refund Processed' },
        { id: 2, key: 'Charge Processed', label: 'Charge' },
        { id: 3, key: 'Added Credit', label: 'Added Credit' },
        { id: 4, key: 'Removed Credit', label: 'Removed Credit' },
        { id: 4, key: 'Issue Still Pending', label: 'Issue Still Pending' },
      ],
      required: true,
    },
    {
      label: 'Adjustment Amount(s)',
      type: 'number',
      required: true,
    },
    {
      label: 'Adjustment Reason',
      type: 'text',
      required: true,
      full: true,
    },
  ],
  chargeError: [
    {
      label: 'Type of request for Grocery VA',
      type: 'select',
      options: [
        { id: 1, key: 'REFUND to Card', label: 'REFUND to Card' },
        { id: 2, key: 'REFUND in GoGo Credits', label: 'REFUND in GoGo Credits' },
        { id: 3, key: 'CHARGE to Card', label: 'CHARGE to Card' },
        { id: 4, key: 'CHARGE in GoGo Credits', label: 'CHARGE in GoGo Credits' },
      ],
      required: true,
    },
    {
      label: 'Provide Incorrect amount charged',
      type: 'number',
      required: true,
    },
    {
      label: 'Details of correct amount to charge',
      type: 'text',
      required: true,
      full: true,
    },
    typeOfRefundField,
  ],
  damagedItemsDispute: [
    {
      type: 'multiple',
      groups: [
        {
          fields: [
            {
              label: 'Select Reason',
              type: 'select',
              required: true,
              options: [
                { id: 1, key: 'Item not properly temp controlled', label: 'Item not properly temp controlled' },
                { id: 1, key: 'Poor Item quality', label: 'Poor Item quality' },
                { id: 1, key: 'Item expired', label: 'Item expired' },
                { id: 1, key: 'Damaged packaging', label: 'Damaged packaging' },
              ],
            },
            {
              label: 'Incorrect Item(s): description & Cost per Item',
              type: 'text',
              required: true,
            },
            {
              label: 'Correct Item(s): description & Cost per Item',
              type: 'text',
              required: true,
              offset: true,
            },
          ],
        },
      ],
    },
    {
      label: 'Notes',
      type: 'text',
      required: true,
      full: true,
    },
    typeOfRefundField,
  ],
  missingWrongPoorReplacement: [
    {
      type: 'multiple',
      groups: [
        {
          fields: [
            {
              label: 'Type of Dispute',
              type: 'select',
              options: [
                { id: 1, key: 'Missing Items', label: 'Missing Items' },
                { id: 2, key: 'Wrong Items', label: 'Wrong Items' },
                { id: 3, key: 'Poor Replacements', label: 'Poor Replacements' },
              ],
              required: true,
            },
            {
              label: 'Incorrect Item(s): description & Cost per Item',
              type: 'text',
              required: true,
            },
            {
              label: 'Correct Item(s): description & Cost per Item',
              type: 'text',
              required: true,
              offset: true,
            },
          ],
        },
      ],
    },
    {
      label: 'Notes',
      type: 'text',
      required: true,
      full: true,
    },
    typeOfRefundField,
  ],
  poorServiceByIC: [
    {
      label: 'Type of poor service being reported',
      type: 'multiple-select',
      options: [
        { id: 1, key: 'Shopper communication', label: 'Shopper communication' },
        { id: 2, key: 'Shopper professionalism', label: 'Shopper professionalism' },
        { id: 3, key: 'Shopper friendliness', label: 'Shopper friendliness' },
        { id: 4, key: 'Complaint about the delivery time change', label: 'Complaint about the delivery time change' },
      ],
      required: true,
    },
    {
      label: 'Did you Remove the Tip',
      type: 'select',
      options: [
        { id: 1, key: 'Yes', label: 'Yes' },
        { id: 2, key: 'No', label: 'No' },
      ],
      required: true,
    },
    {
      label: 'How much',
      type: 'number',
      required: true,
    },
    {
      label: 'Was it after we charged the customer',
      type: 'select',
      options: [
        {
          id: 1,
          key: 'Removed the tip Before we charged the customer in the dash. Tip will auto adjust.',
          label: 'Removed the tip Before we charged the customer in the dash. Tip will auto adjust.',
        },
        {
          id: 3,
          key: 'No Tip Removal was processed customer only wanted to file complaint',
          label: 'No Tip Removal was processed customer only wanted to file complaint',
        },
        {
          id: 4,
          key: 'Tip was removed after we fully charged the customer VA needs to do manual adjustment',
          label: 'Tip was removed after we fully charged the customer VA needs to do manual adjustment',
        },
      ],
      required: true,
    },
    {
      label: 'Details about the issue',
      type: 'text',
      required: true,
      full: true,
    },
  ],
  operatorError: [
    {
      label: 'Is this associated with an Other Circumstance Dispute',
      type: 'select',
      options: [
        { id: 1, key: 'Yes', label: 'Yes' },
        { id: 2, key: 'No', label: 'No' },
      ],
      required: true,
    },
    {
      label: 'Error',
      type: 'multiple-select',
      options: [
        {
          id: 1,
          key: 'Did not not include APT, Unit, Condo, BLDG in address field',
          label: 'Did not not include APT, Unit, Condo, BLDG in address field',
        },
        { id: 2, key: 'Did not enter proper replacement Item', label: 'Did not enter proper replacement Item' },
        {
          id: 3,
          key: 'Did Not enter Instructions for specific Item in the list',
          label: 'Did Not enter Instructions for specific Item in the list',
        },
        { id: 4, key: 'Did Not Select NO Replacement', label: 'Did Not Select NO Replacement' },
        { id: 5, key: 'Did Not Submit NL', label: 'Did Not Submit NL' },
        { id: 6, key: 'Did not select right quantity of item', label: 'Did not select right quantity of item' },
        { id: 7, key: 'Sent Groceries to Wrong Address', label: 'Sent Groceries to Wrong Address' },
        { id: 8, key: 'No Shopper notes', label: 'No Shopper notes' },
        { id: 9, key: 'Wrong Dashboard Shopper Note ', label: 'Wrong Dashboard Shopper Note ' },
        { id: 10, key: 'Item Not Added to Cart', label: 'Item Not Added to Cart' },
        { id: 11, key: 'Added Incorrect Item', label: 'Added Incorrect Item' },
        { id: 12, key: 'Did Not Submit Grocery Order ID', label: 'Did Not Submit Grocery Order ID' },
        { id: 13, key: 'Created incorrect NL', label: 'Created incorrect NL' },
        { id: 14, key: 'Miss information to the cx', label: 'Miss information to the cx' },
        { id: 15, key: 'Failed to add call log note', label: 'Failed to add call log note' },
        { id: 16, key: 'Incorrect delivery time and date', label: 'Incorrect delivery time and date' },
        { id: 17, key: 'Incorrect order total given to the customer', label: 'Incorrect order total given to the customer' },
        { id: 18, key: 'Other', label: 'Other' },
      ],
    },
    {
      label: 'Details',
      type: 'text',
      full: true,
    },
  ],
  supervisorInteraction: [
    {
      label: 'What is the type of issue?',
      type: 'select',
      options: [
        { id: 1, key: 'Other Circumstances', label: 'Other Circumstances' },
        { id: 2, key: 'Adjustement Request to VA', label: 'Adjustement Request to VA' },
        { id: 3, key: 'Charge Error', label: 'Charge Error' },
        { id: 4, key: 'Damaged Items Dispute', label: 'Damaged Items Dispute' },
        { id: 5, key: 'Missing, Wrong or Poor Replacement', label: 'Missing, Wrong or Poor Replacement' },
        { id: 6, key: 'Poor Service by IC/Tip Removal', label: 'Poor Service by IC/Tip Removal' },
        { id: 7, key: 'Past Due Dispute Follow up', label: 'Past Due Dispute Follow up' },
      ],
      required: true,
      full: true,
    },
    {
      label: 'What did the customers say',
      type: 'text',
    },
    {
      label: 'Actions taken by the supervisor',
      type: 'text',
    },
    typeOfRefundField,
  ],
  escalatedBug: [
    {
      label: 'Account that is having the issue',
      type: 'input',
      required: true,
    },
    {
      label: 'Did this prevent you from placing an order?',
      type: 'select',
      options: [
        { id: 1, key: 'Yes', label: 'Yes' },
        { id: 2, key: 'No', label: 'No' },
      ],
      required: true,
    },
    {
      label: 'Describe in detail the issue',
      type: 'text',
      full: true,
    },
  ],
  missingOrder: [
    {
      label: 'Item(s): description & Cost per Item',
      type: 'text',
      required: true,
    },
    typeOfRefundField,
  ],
};

export const groceryChargeRefundReasonList: ListType[] = [
  { id: 1, key: 'Adjustment Request by an Operator', label: 'Adjustment Request by an Operator' },
  { id: 2, key: 'Other Circumstances', label: 'Other Circumstances' },
  { id: 3, key: 'Disputes - Damaged Items', label: 'Disputes - Damaged Items' },
  { id: 4, key: 'Disputes - Missing Items', label: 'Disputes - Missing Items' },
  { id: 5, key: 'Disputes - Wrong Items', label: 'Disputes - Wrong Items' },
  { id: 6, key: 'Disputes - Poor Replacements', label: 'Disputes - Poor Replacements' },
  { id: 7, key: 'Operator Error', label: 'Operator Error' },
  { id: 8, key: 'Retention', label: 'Retention' },
  { id: 9, key: 'Canada Order', label: 'Canada Order' },
];

export const savedGroceryTypeList: ListType[] = [
  { id: 0, key: 'defaultCart', label: 'Default Cart' },
  { id: 1, key: 'recipeList', label: 'Recipe List' },
  { id: 2, key: 'favoriteGrocery', label: 'Favorite Grocery' },
];

export const groceryNeedLoveResolutionTypeList: ListType[] = [
  { id: 1, key: 'LP messaged everything ok', label: 'LP messaged everything ok' },
  { id: 2, key: 'VA messaged everything ok', label: 'VA messaged everything ok' },
  { id: 3, key: 'No message sent - no answer left voicemail', label: 'No message sent - no answer left voicemail' },
  { id: 4, key: 'Spoke with customer - everything ok', label: 'Spoke with customer - everything ok' },
  {
    id: 5,
    key: 'Filed with Instacart - Instacart credited/refunded customer',
    label: 'Filed with Instacart - Instacart credited/refunded customer',
  },
  { id: 6, key: 'Filed with Instacart - Instacart declined', label: 'Filed with Instacart - Instacart declined' },
  {
    id: 7,
    key: 'Filed with Instacart - GoGo retention due to Instacart dispute',
    label: 'Filed with Instacart - GoGo retention due to Instacart dispute',
  },
  { id: 8, key: 'Operator error - GoGo refund/credit issued', label: 'Operator error - GoGo refund/credit issued' },
];

export const disabilityTypeList: ListType[] = [
  { id: 1, key: 'non-elderly or impaired', label: 'non-elderly or impaired' },
  { id: 2, key: 'an elderly woman', label: 'an elderly woman' },
  { id: 3, key: 'an elderly woman with mobility issues', label: 'an elderly woman with mobility issues' },
  { id: 4, key: 'an elderly woman with visibility issues', label: 'an elderly woman with visibility issues' },
  { id: 5, key: 'an elderly woman with hearing impairment', label: 'an elderly woman with hearing impairment' },
  { id: 6, key: 'an elderly man', label: 'an elderly man' },
  { id: 7, key: 'an elderly man with mobility issues', label: 'an elderly man with mobility issues' },
  { id: 8, key: 'an elderly man with visibility issues', label: 'an elderly man with visibility issues' },
  { id: 9, key: 'an elderly man with hearing impairment', label: 'an elderly man with hearing impairment' },
];

export const groceryCancelTypeList: ListType[] = [
  { id: 0, key: '0', label: "New delivery time didn't work" },
  { id: 1, key: '1', label: 'Items were out of stock' },
  { id: 2, key: '2', label: "I don't need this order anymore" },
  { id: 3, key: '3', label: 'I created a duplicate order' },
  { id: 4, key: '4', label: 'I want to change my order' },
  { id: 5, key: '5', label: "There's a problem with my order" },
  { id: 6, key: '6', label: 'Other' },
];
